// extracted by mini-css-extract-plugin
module.exports = {"advertisement":"_1p4yo"};